import {formatCurrency} from "../../common/utilities";
import {InfoIcon} from "../../common/icons";
import KSMPopover from "../../common/Popovers";
import {
    appliedOnkey,
    FSATotalToolTipKey,
    mainMessages,
    totalKey
} from "../../../assets/text/MultilingualText";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useLocalization} from "@progress/kendo-react-intl";
import UserContext from "../../common/UserContext";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";

export const TotalCell = props => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        uniqueID,
        parentUniqueID
    } = useContext(GeneralContext);

    const {
        selectedProducts
    } = useContext(SelectedProductContext);

    const {
        assignedProducts
    } = useContext(AssignedProductContext);

    const localization = useLocalization();
    const anchor = useRef(null);

    const [qty, setQty] = useState(0);
    const [totalCost, setTotalCost] = useState(0);

    useEffect(() => {
        const newQty = props.dataItem['saved_selected_quantity']
        setQty(newQty)
        setTotalCost(newQty * props.dataItem['discount_price'])
    }, [[props.dataItem]])

    const [popoverShow, setPopoverShow] = useState(false)

    const onMouseOver = () => {
        setPopoverShow(true);
    };

    const onMouseOut = (ev) => {
        let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
        if (!isChildEl) setPopoverShow(false);
    };

    return (
        <td>
            <div style={{
                display: "flex",
                justifyContent: "end",
                flexWrap: "nowrap",
                whiteSpace: "nowrap",
            }}>
                <div>
                    {formatCurrency(
                        totalCost,
                        props.dataItem['currency_locale'],
                        props.dataItem['currency_code'])
                    }
                </div>
                <div ref={anchor} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                    <InfoIcon
                        style={{
                            color: 'var(--keysight-secondary)',
                            cursor: 'pointer',
                            marginLeft: '5px',
                        }}
                    />
                </div>
                <KSMPopover
                    show={popoverShow}
                    anchor={anchor.current}
                    position={'top'}
                    type={'info'}
                    style={{
                        minWidth: '20rem'
                    }}
                    message={<div>
                        <b>{localization.toLanguageString(totalKey, mainMessages[siteLanguageDefault][totalKey])}</b>
                        <br/>
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            {localization.toLanguageString(FSATotalToolTipKey, mainMessages[siteLanguageDefault][FSATotalToolTipKey])} &times; Qty =
                            <br/>
                            ({props.dataItem['discount_percentage']}% &nbsp;
                            {localization.toLanguageString(appliedOnkey, mainMessages[siteLanguageDefault][appliedOnkey])} &nbsp;
                            {formatCurrency(
                                props.dataItem['price'],
                                props.dataItem['currency_locale'],
                                props.dataItem['currency_code'])
                            })
                            &times;&nbsp;
                            {qty} &nbsp;=&nbsp;
                            <br/>
                            {formatCurrency(
                                totalCost,
                                props.dataItem['currency_locale'],
                                props.dataItem['currency_code'])
                            }
                        </div>
                    </div>}
                />
            </div>
        </td>
    )
}